import flocknoteStateHooks from "Flocknote/stateHooks";

export function useIsFeatureFlagEnabled() {
  const [{ hasManageMyGivingPage }] = flocknoteStateHooks.useNetworkMetadata();

  return hasManageMyGivingPage;
}
